import { Component } from '@angular/core';
import { SectionTooltipService } from 'src/app/services/section-tooltip/section-tooltip.service';

@Component({
  selector: 'app-section-tooltip',
  templateUrl: './section-tooltip.component.html',
  styleUrls: ['./section-tooltip.component.scss'],
})
export class SectionTooltipComponent {
  constructor(public tooltip: SectionTooltipService) {}

  onTooltipEnter() {
    this.tooltip.cancelHide();
    this.tooltip.tooltipHovered = true;
  }

  onTooltipLeave() {
    this.tooltip.tooltipHovered = false;
    this.tooltip.scheduleHide();
  }
}
